import i18n from 'i18n';

const PROBLEM_MESSAGE_PATTERNS: Array<{ match: RegExp; key: string }> = [
  { match: /missing from master/i, key: 'problemScreen.messages.missingFromMaster' },
  { match: /multiple packages found/i, key: 'problemScreen.messages.multiplePackagesFound' },
  { match: /package not found/i, key: 'problemScreen.messages.packageNotFound' },
  {
    match: /^license is assigned to a carton$/i,
    key: 'palletBuild.messages.licenseAssignedToCase',
  },
  {
    match: /^license is assigned to a pallet$/i,
    key: 'palletBuild.messages.licenseAssignedToPallet',
  },
  {
    match: /^license is assigned to a location$/i,
    key: 'palletBuild.messages.licenseAssignedToLocation',
  },
  { match: /^carton cannot be changed$/i, key: 'palletBuild.messages.caseCannotBeChanged' },
  { match: /^pallet cannot be changed$/i, key: 'palletBuild.messages.palletCannotBeChanged' },
  {
    match: /^product does not exist for callback$/i,
    key: 'palletBuild.messages.productNotEligibleForCallback',
  },
  { match: /^product not found in carton$/i, key: 'palletBuild.messages.productNotFoundInCase' },
  { match: /^pallet does not exist$/i, key: 'palletBuild.messages.palletDoesNotExist' },
  {
    match: /^failed to update carton pallet assignment\.?$/i,
    key: 'palletBuild.messages.failedToAssignCaseToPallet',
  },
  { match: /^carton not found in pallet$/i, key: 'palletBuild.messages.caseNotFoundInPallet' },
  {
    match: /^failed to remove carton from the pallet$/i,
    key: 'palletBuild.messages.failedToRemoveCaseFromPallet',
  },
  { match: /^pallet not found$/i, key: 'palletBuild.messages.palletNotFound' },
  { match: /^location does not exist\.?$/i, key: 'palletBuild.messages.locationDoesNotExist' },
  { match: /^location is not available$/i, key: 'palletBuild.messages.locationNotAvailable' },
  {
    match: /^failed to update pallet location assignment$/i,
    key: 'palletBuild.messages.failedToAssignPalletToLocation',
  },
  { match: /^internal server error$/i, key: 'palletBuild.messages.internalServerError' },
  { match: /^database error$/i, key: 'palletBuild.messages.internalServerError' },
];

export const translateProblemMessage = (message?: string | null): string | null => {
  if (!message) return null;

  const alreadyArrivedMatch = message.match(/already arrived\s+(\S+)/i);
  if (alreadyArrivedMatch) {
    return i18n.t('problemScreen.messages.alreadyArrived', { rmaId: alreadyArrivedMatch[1] });
  }

  if (/package not found via tracking#/i.test(message)) {
    return i18n.language.startsWith('en')
      ? message
      : `findPackage - ${i18n.t('problemScreen.messages.packageNotFound')}#`;
  }

  const matched = PROBLEM_MESSAGE_PATTERNS.find(({ match }) => match.test(message));

  return matched ? i18n.t(matched.key) : message;
};
